const ROUTE_STATUS = {
  waitingForPickup: {
    name: 'WAITING_FOR_PICKUP',
    icon: '⏱',
    packerIcon: '',
  },
  inPacking: {
    name: 'IN_PACKING',
    icon: '💃',
    packerIcon: '💃',
  },
  readyForPickup: {
    name: 'READY_FOR_PICKUP',
    icon: '👜',
    packerIcon: '✅',
  },
  inProgress: {
    name: 'IN_PROGRESS',
    icon: '🚙',
    packerIcon: '🚙',
  },
  finished: {
    name: 'FINISHED',
    icon: '✅',
    packerIcon: '✅',
  },
};

export default ROUTE_STATUS;
